import { Project } from "pmt-types/src/models/Project.ts";
import { useQuery } from "react-query";
import { Maybe } from "../../utils/types/maybe.ts";
import { useAuthentication } from "../useAuthentication.ts";
import { QueryKeys } from "./queryKeys.ts";

export const useQueryGetProjectById = (
  sourceId: Maybe<string>,
  projectId: Maybe<string>,
) => {
  const { accessToken } = useAuthentication();

  return useQuery(
    [QueryKeys.GetProject, projectId],
    async () => {
      const response = await fetch(
        `${
          import.meta.env.VITE_API_HOST
        }/sources/${sourceId}/projects/${projectId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to query source");
      }

      return (await response.json()) as Project;
    },
    {
      enabled: sourceId != null && projectId != null && projectId != "new",
      onError: (error) => {
        console.error("Failed to get project", error, projectId);
      },
    },
  );
};
